import { TableRow, TableCell, Grid, Paper } from "@material-ui/core";
import {
  Add,
  Clear,
  CloudUpload,
  DeleteForever,
  DoneAll,
  FindInPage,
  // Receipt,
} from "@material-ui/icons";
import {
  MasterButton,
  // TableAction,
  // TableWrapper,
  Loading,
  // Modal,
  ModalDeleteConfirm,
  // DatatablesFooterServerSide,
  // TableCellDefault,
  // InputCheckboxMaster,
  TableAction,
  DatatablesFooterServerSide,
  Title,
  TableToolbar,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
// import { instance3 } from "App/constants";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
} from "App/utils/helpers";
import { RenderStatusPembelian } from "App/Component/layout/Penjualan/DaftarPenjualan/helpers";
import React, { useState, useContext } from "react";
import { FormContext } from "../../context/FormContext";
import { bulkHapusTagihan, headCells } from "./helpers";
import {
  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA,
  STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI,
  getDetailDataTagihanById,
} from "../helpers";
// import { FreezeTable } from "components/organism";
import ModalListTagihan from "./ModalListTagihan";
import { FreezeTable } from "components/organism";
import { toFirstHoursDay, toLastHoursDay } from "utils/dates";
import ModalImport from "./ModalImport";
import { BILLING_INPUT_TAGIHAN, instance3 } from "App/constants";
import {
  changeActiveMenu,
  changeActiveTab,
  changePagePropsInputTagihan,
} from "App/Component/layout/Wrapper/context/actions";
import { useDispatchWrapper } from "hooks";
import { getTagihanById } from "App/Component/layout/Tagihan/InputTagihan/ui";
import ModalLog from "./ModalLog";
import FormFilterDataRekapTagihan from "./FormFilterDataRekapTagihan";

function TabTagihan({
  setNewData,
  setAllNewData,
  setNewDataLog,
  loading,
  setLoading,
}) {
  const [showModalListTagihan, setShowModalListTagihan] = useState(false);
  const [showModalImport, setShowModalImport] = useState(false);
  const [showModalLog, setShowModalLog] = useState(false);
  const [showModalPembayaran, setShowModalPembayaran] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const {
    formData,
    setRowsTagihan,
    rowsTagihan,
    rowsSelect,
    setRowsSelect,
    setTotalDataTagihan,
    totalDataTagihan,
    formFilterTagihan,
  } = useContext(FormContext);
  // console.log("totalDataTagihan", totalDataTagihan);
  const { dispatch, handleClickMenu } = useDispatchWrapper();

  const handleClickUpdate = async (row) => {
    setLoading(true);

    /**
     * Ubah menjadi reducer
     */

    Promise.resolve()
      .then(() => {
        dispatch(changeActiveMenu(BILLING_INPUT_TAGIHAN));
      })
      .then(async () => {
        const api = await instance3.post("/tagihan/list", {
          halaman: 1,
          jumlah: 10,
          nama: "",
          eklaim_status: "",
          tanggal_awal: "",
          tanggal_akhir: "",
          asuransi_id: null,
          jenis_layanan_id: null,
          id_tagihan: row.id_tagihan,
        });
        const datas = api.data;
        if (datas.status === 200) {
          const hasil = datas.data[0];
          const res = await getTagihanById(hasil.id);
          if (res.state) {
            const tagihan = res.data.tagihan;
            const pembayaran = res.data.pembayaran;
            const ditanggung = res.data.ditanggung;

            const propsPageInputTagihan = {
              tagihan_id: hasil.id,
              date: defaultDateInputDisplay(hasil.tanggal_tagihan, true),
              type: "update",
              rm_id: hasil.rm_id,
              rm_name: hasil.nama,
              rm_umur: hasil.rm_umur,
              kelas_id: hasil.kelas_id,
              kelas_name: hasil.nama_kelas,
              asuransi_no: hasil.no_asuransi,
              asuransi_id: hasil.asuransi_id,
              asuransi: hasil.nama_asuransi,
              jenis_layanan_id: hasil.jenis_layanan_id,
              jenis_layanan_name: hasil.nama_layanan,
              kunjungan_id: "",
              no_sep: hasil.no_sep,
              no_npwp: hasil.no_npwp,
              keterangan: hasil.keterangan,
              penanggung: hasil.penanggung,
              jenisrm: 2,
              status: hasil.statusTagihan !== 0 ? 1 : 0,
              status_tagihan: parseInt(hasil.statusTagihan),
              // tagihan: {
              //   jumlah: tagihan.jumlah,
              //   potongan: tagihan.potongan,
              //   tax: tagihan.tax,
              // },
              // pembayaran: {
              //   total_tagihan: pembayaran.total_tagihan,
              //   total_pembayaran: pembayaran.total_pembayaran,
              // },
              // ditanggung: {
              //   ditanggung: ditanggung.ditanggung,
              //   total_tagihan: ditanggung.total_tagihan,
              // },

              tagihan: {
                jumlah: tagihan.jumlah,
                potongan: tagihan.potongan,
                tax: tagihan.tax,
              },

              pembayaran: {
                total_tagihan: pembayaran.total_tagihan,
                total_pembayaran: pembayaran.total_pembayaran,
              },

              ditanggung: {
                ditanggung: ditanggung.ditanggung,
                total_tagihan: ditanggung.total_tagihan,
                jumlah_selisih: ditanggung.jumlah_selisih,
              },
            };

            dispatch(changePagePropsInputTagihan(propsPageInputTagihan));
            dispatch(changeActiveTab(BILLING_INPUT_TAGIHAN));
            handleClickMenu({
              code: BILLING_INPUT_TAGIHAN,
              name: "Input Tagihan",
            });
          } else {
            defaultToastError(res.message);
          }
        } else {
          defaultToastError(api.message);
        }
        setLoading(false);
      });
  };

  // const {
  //   page,
  //   setQ,
  //   setPage,
  //   setRowsPerPage,
  //   data,
  //   order,
  //   orderBy,
  //   handleRequestSort,
  //   length,
  //   rowsPerPage,
  // } = useDatatables({
  //   rows: rowsTagihan,
  //   orderByDefault: "sisa_tagihan",
  //   orderByRow: ["sisa_tagihan", "id_tagihan", "nama_rm", "rm_id", "penanggung", "no_asuransi"],
  // });

  const setNewDataTabTagihan = async (pages=1, limit=10) => {
    try {
      setLoading(true);
      const response = await getDetailDataTagihanById(
        { ...formFilterTagihan, id_rekap: formData.rekap_tagihan_id },
        pages,
        limit
      );
      if (response.state) {
        setRowsTagihan(response.data);
        setTotalDataTagihan(response.meta.count);
        setLoading(false);
      } else {
        setRowsTagihan([]);
        setLoading(false);
        setTotalDataTagihan(0);
        defaultToastError(response.message);
      }
    } catch (error) {
      setLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rowsTagihan,
    orderByDefault: "sisa_tagihan",
    orderByRow: [
      "sisa_tagihan",
      "id_tagihan",
      "nama_rm",
      "rm_id",
      "nama_asuransi",
      "no_asuransi",
    ],
  });

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({ setNewData: setNewDataTabTagihan });

  const newSetNewData = async () => {
    resetPagination();
    await setNewData();
  };

  // const handleBulkTagihan = async (row) => {
  //   const response = await addBulkTagihan(formData.rekap_tagihan_id, row);
  //   if (response.state) {
  //     await setNewData();
  //     return {
  //       state: true,
  //       message: response.message,
  //     };
  //   } else {
  //     return {
  //       state: false,
  //       message: response.message,
  //     };
  //   }
  // };

  const handleBulkHapusTagihan = async (row) => {
    const response = await bulkHapusTagihan(formData.rekap_tagihan_id, row);
    if (response.state) {
      await setNewData();
      resetPagination();
      setRowsSelect([]);
      return {
        state: true,
        message: response.message,
      };
    } else {
      return {
        state: false,
        message: response.message,
      };
    }
  };

  const handleClickSingleSelect = (row) => {
    const filter = rowsSelect.filter((item) => item.id === row.id);
    if (filter.length > 0) {
      const filterExcept = rowsSelect.filter((item) => item.id !== row.id);
      setRowsSelect(filterExcept);
    } else {
      setRowsSelect([...rowsSelect, row]);
    }
  };

  const handleClickAllSelect = () => {
    const all = rowsTagihan;
    // const all = stableSort(data, getComparator(order, orderBy)).slice(
    //   page * rowsPerPage,
    //   page * rowsPerPage + rowsPerPage
    // );

    // Select Perpage
    // const _temp = [];
    // all.map((item) => _temp.push(item));
    // setRowsSelect(_temp);

    // experiment select all berkeleanjutan
    let _temp = [];
    all.map((item) => _temp.push(item));
    const oldRowSelect = all.filter((o) =>
      Object.keys(rowsSelect).every((k) => rowsSelect[k] !== o[k])
    );
    setRowsSelect(
      rowsSelect.concat(
        oldRowSelect.filter((bo) => rowsSelect.every((ao) => ao.id != bo.id))
      )
    ); //eslint-disable-line
  };

  const checkAlready = (id) => {
    const filter = rowsSelect.filter((item) => item.id === id);
    return filter.length > 0 ? true : false;
  };

  const handleClickReset = () => {
    setRowsSelect([]);
  };

  // const handleClickSimpan = async () => {
  //   setLoading(true);
  //   const response = await handleBulkTagihan(rowsSelect);
  //   if (response.state) {
  //     defaultToastSuccess(response.message);
  //     setLoading(false);
  //   } else {
  //     defaultToastError(response.message);
  //     setLoading(false);
  //   }
  // };

  const handleClickHapus = async () => {
    setLoading(true);
    if (rowsSelect.length === 0) {
      defaultToastError(
        "Harap pilih tagihan yang ingin dihapus terlebih dahulu!"
      );
      setLoading(false);
    } else {
      const response = await handleBulkHapusTagihan(rowsSelect);
      if (response.state) {
        defaultToastSuccess(response.message);
        setLoading(false);
      } else {
        defaultToastError(response.message);
        setLoading(false);
      }
    }
    setShowModalDeleteConfirm(false);
  };

  const deleteTagihan = async () => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          title="Hapus Tagihan"
          msg="Apakah anda yang ingin menghapus secara permanen pada tagihan yang sudah dipilih?"
          confirmHandle={() => handleClickHapus()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {showModalListTagihan && (
        <ModalListTagihan
          setShowModal={() => setShowModalListTagihan(false)}
          setNewDataTagihan={newSetNewData}
          asuransiID={formData.asuransi_id}
          asuransiNama={formData.asuransi_nama}
          tanggal_awal={toFirstHoursDay(formData.tanggal_periode_awal)}
          tanggal_akhir={toLastHoursDay(formData.tanggal_periode_akhir)}
        />
      )}

      {showModalImport && (
        <ModalImport
          setShowModal={() => setShowModalImport(false)}
          setNewData={newSetNewData}
          datas={formData}
          withDetail={true}
          url={"/rekap-tagihan/upload-tagihan"}
          urlGetImport={"/rekap-tagihan/list-log-rekap"}
          urlDetail={"/rekap-tagihan/list-log-id"}
          status_proses={formData.status_proses}
        />
      )}

      {showModalPembayaran && (
        <ModalImport
          setShowModal={() => setShowModalPembayaran(false)}
          setNewData={newSetNewData}
          datas={formData}
          withDetail={true}
          title={"Import Data Pembayaran"}
          subTitle={"Daftar Import Pembayaran"}
          url={""}
        />
      )}

      {showModalLog && (
        <ModalLog
          setShowModal={() => setShowModalLog(false)}
          setNewData={setNewDataLog}
          datas={formData}
        />
      )}

      <Paper className="p-1">
        {/* <FreezeTableClient
        title="Daftar Tagihan"
        setQ={setQ}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rowsTagihan}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      > */}
        {/* <TableToolbar title="Daftar Tagihan" /> */}
        <FormFilterDataRekapTagihan fetchData={setNewDataTabTagihan} />
        <Loading show={loading} />
        <FreezeTable
          headCells={headCells}
          handleRequestSort={handleRequestSort}
          order={order}
          length={length}
          orderBy={orderBy}
        >
          {/* {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => { */}
          {stableSort(rowsTagihan, getComparator(order, orderBy)).map(
            (row, index) => {
              return (
                <TableRow hover tabIndex={-1} key={index}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell>
                    {row?.sisa_tagihan === 0 ? (
                      <>
                        <TableAction
                          isUpdate={false}
                          isDelete={false}
                          isSelect={true}
                          isDisabledCheck={true}
                          clickSelect={() => handleClickUpdate(row)}
                          isCheck={true}
                          clickCheck={(e) => null}
                          checked={checkAlready(row.id)}
                        />
                      </>
                    ) : (
                      <>
                        <TableAction
                          isUpdate={false}
                          isDelete={false}
                          isSelect={true}
                          clickSelect={() => handleClickUpdate(row)}
                          isCheck={true}
                          clickCheck={(e) => handleClickSingleSelect(row)}
                          checked={checkAlready(row.id)}
                        />
                      </>
                    )}
                  </TableCell>
                  <TableCell align="left">{row?.id_tagihan}</TableCell>
                  <TableCell align="left">{row?.nama_rm}</TableCell>
                  <TableCell align="left">{row?.rm_id}</TableCell>
                  <TableCell align="center">
                    <RenderStatusPembelian status={row?.status_pembayaran} />
                  </TableCell>
                  <TableCell align="left">
                    {defaultDateDisplay(row?.tanggal_tagihan, true)}
                  </TableCell>
                  {/* <TableCell align="left">
                  {isNull(row?.penanggung) ? "-" : row?.penanggung}
                </TableCell> */}
                  {/* <TableCell align="left">
                  {defaultDateDisplay(row?.tgl_perawatan_awal, true)}
                </TableCell> */}
                  {/* <TableCell align="left">
                  {defaultDateDisplay(row?.tgl_perawatan_akhir, true)}
                </TableCell> */}
                  <TableCell align="left">
                    {isNull(row?.nama_asuransi) ? "-" : row?.nama_asuransi}
                  </TableCell>
                  <TableCell align="left">
                    {isNull(row?.no_asuransi) ? "-" : row?.no_asuransi}
                  </TableCell>
                  {/* <TableCell align="left">
                  {isNull(row?.nama_layanan) ? "-" : row?.nama_layanan}
                </TableCell> */}
                  <TableCell align="right">
                    {formatNumber(row?.totaltagihan)}
                  </TableCell>
                  {/* <TableCell align="right">
                  {formatNumber(isNull(row?.selisihTagihan) ? 0 : row?.selisihTagihan)}
                </TableCell> */}
                  {/* <TableCell align="right">
                  {formatNumber(row?.total_dibayar)}
                </TableCell> */}
                  <TableCell align="right">
                    {formatNumber(row?.total_bayar)}
                  </TableCell>
                  <TableCell align="right">
                    {formatNumber(row?.sisa_tagihan)}
                  </TableCell>

                  {/* <TableCellDefault row={row} /> */}
                </TableRow>
              );
            }
          )}
          {/* </FreezeTableClient> */}
        </FreezeTable>
        <DatatablesFooterServerSide
          totalData={totalDataTagihan}
          pagination={pagination}
          handleChangeLimit={handleChangeLimit}
          onPrevious={onPrevious}
          onNext={onNext}
          currentPage={pagination.page}
          handleClickPageNumber={handleClickPageNumber}
        />
      </Paper>
      <div>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <MasterButton
              type={"button"}
              color={"lightgreen"}
              outline={true}
              // disabeled={
              //   formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA
              //     ? false
              //     : true
              // }
              onClick={(e) => setShowModalImport(!showModalImport)}
              name="Import Tagihan"
              size="sm"
              withIcon={true}
              icon={<CloudUpload width="15px" height="15px" />}
            />
            {/* <MasterButton
              type={"button"}
              color={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                  ? "lightgreen"
                  : "secondary"
              }
              outline={true}
              disabeled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                  ? false
                  : true
              }
              className={"ml-1"}
              onClick={(e) =>
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                  ?  setShowModalPembayaran(!showModalPembayaran)
                  : null
              }
              name="Import Pembayaran"
              size="sm"
              withIcon={true}
              icon={
                <Receipt
                  width="15px"
                  height="15px"
                  style={{
                    marginLeft: "-0.5rem",
                  }}
                />
              }
            /> */}
            <MasterButton
              type={"button"}
              color={
                !isNull(formData.rekap_tagihan_id) ? "lightgreen" : "secondary"
              }
              disabeled={!isNull(formData.rekap_tagihan_id) ? false : true}
              outline={true}
              onClick={(e) =>
                !isNull(formData.rekap_tagihan_id)
                  ? setShowModalLog(!showModalLog)
                  : null
              }
              name="Log Proses Berjalan"
              size="sm"
              withIcon={true}
              icon={<FindInPage width="15px" height="15px" />}
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          >
            <MasterButton
              type={"button"}
              color={
                (formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA &&
                  rowsSelect.length > 0) ||
                (formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI &&
                  rowsSelect.length > 0)
                  ? "danger"
                  : "secondary"
              }
              outline={true}
              disabeled={
                (formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA &&
                  rowsSelect.length > 0) ||
                (formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI &&
                  rowsSelect.length > 0)
                  ? false
                  : true
              }
              onClick={(e) =>
                (formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA &&
                  rowsSelect.length > 0) ||
                (formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI &&
                  rowsSelect.length > 0)
                  ? handleClickReset()
                  : null
              }
              name="Batal Seluruh Pilihan"
              size="sm"
              withIcon={true}
              className={"ml-1"}
              icon={
                <Clear
                  width="15px"
                  height="15px"
                  style={{
                    marginLeft: "-0.5rem",
                  }}
                />
              }
            />
            <MasterButton
              type={"button"}
              color={
                (formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA &&
                  rowsTagihan.length > 0) ||
                (formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI &&
                  rowsTagihan.length > 0)
                  ? "green"
                  : "secondary"
              }
              outline={true}
              disabeled={
                (formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA &&
                  rowsTagihan.length > 0) ||
                (formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI &&
                  rowsTagihan.length > 0)
                  ? false
                  : true
              }
              onClick={(e) =>
                formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA ||
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
                  ? handleClickAllSelect()
                  : null
              }
              name="Pilih Semua Pada Halaman Ini"
              size="sm"
              withIcon={true}
              className={"ml-1"}
              icon={
                <DoneAll
                  width="15px"
                  height="15px"
                  style={{
                    marginLeft: "-0.5rem",
                  }}
                />
              }
            />
            <MasterButton
              type={"button"}
              color={
                formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA && rowsSelect.length > 0
                  ? "danger"
                  : "secondary"
              }
              outline={true}
              disabeled={
                formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA && rowsSelect.length > 0
                  ? false
                  : true
              }
              className={"ml-1"}
              onClick={(e) =>
                formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA && rowsSelect.length > 0
                  ? deleteTagihan()
                  : null
              }
              name="Hapus Permanen Pilihan"
              size="sm"
              withIcon={true}
              icon={
                <DeleteForever
                  width="15px"
                  height="15px"
                  style={{
                    marginLeft: "-0.5rem",
                  }}
                />
              }
            />
            <MasterButton
              type={"button"}
              color={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA
                  ? "lightgreen"
                  : "secondary"
              }
              outline={true}
              disabeled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA
                  ? false
                  : true
              }
              className={"ml-1"}
              onClick={(e) =>
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA
                  ? setShowModalListTagihan(!showModalListTagihan)
                  : null
              }
              name="Tambah Tagihan"
              size="sm"
              withIcon={true}
              icon={
                <Add
                  width="15px"
                  height="15px"
                  style={{
                    marginLeft: "-0.5rem",
                  }}
                />
              }
            />
          </div>
        </Grid>
      </div>
    </>
  );
}

export default TabTagihan;
